import React, { useState } from "react";
import FirebaseContext from "./firebase/context";

const Newsletter = (props) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const addNewsletterSubScriber = (e) => {
    setEmailError("");
    e.preventDefault();

    if (email.includes("@") && email.includes(".com")) {
      props.firebase.addNewsletter(email);
      setEmail("");
    } else {
      console.log("invalid Email");
      setEmailError("Invalid Email");
    }
  };

  return (
    <div>
      <form>
        <input
          className="subscribe-input"
          type="email"
          name="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder="eg. example@email.com"
        />
        <input
          type="submit"
          onClick={addNewsletterSubScriber}
          value="Subscribe"
        />
      </form>
      <div className="error-message">{emailError}</div>
      <p id="subscribe-message"></p>
    </div>
  );
};
function Footer() {
  return (
    <div>
      <footer id="footer">
        <div className="footer-top container">
          <div className="row row-cols-lg-4">
            <div className="col-12 col-lg-3 footer-contact">
              <h3>Aligator IT Solutions</h3>
              <p>
                Faridabad <br />
                Haryana - 121003
                <br />
                India <br />
                <br />
                <strong>
                  <i
                    style={{ fontSize: "20px" }}
                    className="fa fa-whatsapp mr-2"
                  ></i>
                </strong>
                +91 9354347667
                <br />
                <strong>
                  <i
                    style={{ fontSize: "18px" }}
                    className="fa  fa-envelope mr-2"
                  ></i>
                </strong>{" "}
                aligatoritsolutions@gmail.com
                <br />
              </p>
            </div>
            <div className="col-12 col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className="fa fa-angle-right"></i> <a href="#hero">Home</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#about">About us</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#contact">Contact us</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="##">T&C</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="##">Privacy policy</a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-lg-3 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i className="fa fa-angle-right"></i>{" "}
                  <a href="#services">Logo Design </a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Data Conversion</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Web Development</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Web Research</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Data Scraping</a>
                </li>
                <li>
                  <i className="fa fa-angle-right"></i>
                  <a href="#services">Data Management</a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-lg-4 col-md-6 footer-newsletter">
              <h4>Join Our Newsletter</h4>
              <p>
                Subscribe to our thought leadership resources, and receive
                industry insights, presentation templates and more in your
                inbox!
              </p>
              <FirebaseContext.Consumer>
                {(firebase) => <Newsletter firebase={firebase} />}
              </FirebaseContext.Consumer>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright-wrap d-md-flex py-4">
            <div className="mr-md-auto text-center text-md-left">
              <div className="copyright">
                &copy; Copyright{" 2020 "}
                <strong>
                  <span>Aligator IT Solutions</span>
                </strong>
                . All Rights Reserved
              </div>
              <div className="credits">
                Designed by <a href="##">Team Aligator</a>
              </div>
            </div>
            <div className="social-links text-center text-md-right pt-3 pt-md-0">
              <a href="https://twitter.com/AligatorIt" className="twitter">
                <i className="fa fa-twitter"></i>
              </a>
              <a href="##" className="facebook">
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/aligator_it_solutions/?hl=en"
                className="instagram"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/aligator-it-solutions/" className="linkedin">
                <i className="fa fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
